import { FunctionComponent, useMemo } from 'react'
import { useFilters } from '@/modules/accredited-establishments/hooks'
import { ALL_ID } from '@/modules/accredited-establishments/constants/filters'
import {
  DropdownChip,
  DropdownChipItem
} from '@/modules/accredited-establishments/components/Filters/DropdownChip'

const PlanChip: FunctionComponent = () => {
  const { plans, plan, updatePlan } = useFilters()

  /* `useGetPlansFilter` prefixes the list with `Todos os planos` (`ALL`). */
  const items = useMemo<DropdownChipItem[]>(
    () =>
      (plans?.items || []).map(({ title, value }) => ({
        label: title,
        value
      })),
    [plans]
  )

  const onChange = ({ label, value }: DropdownChipItem) =>
    updatePlan({ title: label, value })

  return (
    <DropdownChip
      placeholder='Todos os planos'
      items={items}
      value={plan?.value || ALL_ID}
      disabled={!items.length}
      onChange={onChange}
    />
  )
}

export { PlanChip }
